import ZShare from './ZShare.vue'

export default ZShare
